import petTableMock from "../mockDb/petTableMock";
import { PETS_URL } from "../../_redux/pets";

export default function mockPet(mock) {
  mock.onPost(PETS_URL).reply((config) => {
    return [200, petTableMock];
  });
}
